import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Göktürk Koltuk Yıkama", path: "/eyupsultan/gokturk-koltuk-yikama" },
  { label: "Göktürk Battaniye Yıkama", path: "/eyupsultan/gokturk-battaniye-yikama" },
  { label: "Rami Koltuk Yıkama", path: "/eyupsultan/rami-koltuk-yikama" },
  { label: "Rami Yatak Yıkama", path: "/eyupsultan/rami-yatak-yikama" },
  { label: "Alibeyköy Koltuk Yıkama", path: "/eyupsultan/alibeykoy-koltuk-yikama" },
  { label: "Alibeyköy Perde Yıkama", path: "/eyupsultan/alibeykoy-perde-yikama" },
  { label: "Yeşilpınar Koltuk Yıkama", path: "/eyupsultan/yesilpinar-koltuk-yikama" },
  { label: "Yeşilpınar Kuru Temizleme", path: "/eyupsultan/yesilpinar-kuru-temizleme" },
  { label: "İslambey Mahallesi Koltuk Yıkama", path: "/eyupsultan/islambey-koltuk-yikama" },
  { label: "İslambey Yerinde Yıkama", path: "/eyupsultan/islambey-yerinde-yikama" },
  { label: "Eyüpsultan Merkez Koltuk Yıkama", path: "/eyupsultan/merkez-koltuk-yikama" }
];

const EyupsultanServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          EYÜPSULTAN HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default EyupsultanServiceArea;
